export default {
    agent: {
        login: 'agent/login',
        card: 'agent/card',
        power: 'agent/power',
        card_list: 'agent/card_list',
        change_password: 'agent/change_password',
        phone_code: 'agent/phone_code',
        access_token: 'agent/access_token',
        bind_phone: 'agent/bind_phone',
        info: 'agent/info',
        teachers: 'agent/teachers',
        cards: 'agent/cards',
        update: 'agent/update',
        students: 'agent/students',
        no_teacher_user_list: 'agent/no_teacher_user_list',
        send_code: 'agent/send_phone_code',
        change_header: 'agent/change_header',
        distribution_student: 'agent/distribution_student',
        distribution_card: 'agent/distribution_card',
        add_teacher: 'agent/add_teacher',
        buy_student_times: 'agent/buy_student_times',
        buy_teacher_times: 'agent/buy_teacher_times',
        pay_times_status: 'agent/pay_times_status',
        pay_teacher_status: 'agent/pay_teacher_status',
    },
}